import { getConnectionPool } from "../../core/connectionPool";
import { request } from "../../proto/bundle";
import { checkMigrate, goTo } from "../../init/sdkInit";

export class BYOS {
    public static async verifyBYOSCred(
        type: string,
        details: { [key: string]: string }
    ): Promise<{ [key: string]: string }[]> {
        // console.log(details)

        const storage = this.createStorage(type, details)
        // console.log(storage)
        const verifyByosCred = request.VerifyBYOSCreds.create({
            storageType: storage
        })
        // console.log("vreify ", verifyByosCred)
        const req = request.Request.create({
            id: null,
            verifyBYOSCreds: verifyByosCred
        })
        // console.log("req", req)
        const pool = await getConnectionPool()
        const statuses: { [key: string]: string }[] = [];
        let verified = false
        try {
            const res = await pool.sendAndWait(req);
            checkMigrate(res.verifyBYOSCreds.status)
            if (res.verifyBYOSCreds.status != 0) {
                throw new Error("Internal Error!!!"+res.verifyBYOSCreds.status);
            }

            for (const oper of res.verifyBYOSCreds.byosOperation) {
                const item = {
                    status: String(oper.status),
                    operations: oper.operation,
                    message: oper.message?? "Nothing",
                };
                if (oper.status == false) {
                    verified = true
                }

                statuses.push(item);
            }
        } catch (error) {
            console.error("Error:", error);
            throw new Error("Failed to send/recv request/response");
        }
        if (verified) {
            return statuses;
        } else {
            return []
        }

    }

    static azureCredsbuilder(
        details: { [key: string]: string }
    ): request.StorageType {
        const accountName = details["accountName"]
        const accountKey = details["accountKey"]
        const connectionString = details["connectionString"]
        if (!accountKey || !accountName || !connectionString) {
            throw new Error("Connection details missing")
        }
        const azureBlob = request.AzureBlob.create({
            accountKey,
            accountName,
            connectionString
        })
        return request.StorageType.create({
            azureBlob: azureBlob
        })
    }

    static minioCredsbuilder(
        details: { [key: string]: string }
    ): request.StorageType {
        // console.log(details)
        const endpoint = details["endpoint"]
        const accessKey = details["accessKey"]
        const secretKey = details["secretKey"]
        const ssl = !(details["ssl"] == "false")
        if (!accessKey || !endpoint || !secretKey ) {
            throw new Error("Connection details missing")
        }
        const minioBlob = request.Minio.create({
            accessKey,
            endpoint,
            secretKey,
            useSsl: ssl
        })
        return request.StorageType.create({
            minio: minioBlob
        })
    }

    static createStorage(
        type: string,
        details: { [key: string]: string }
    ) {
        // console.log(type)
        switch (type) {
            case "Azure":
                return this.azureCredsbuilder(details)
            case "MinIO":
                return this.minioCredsbuilder(details)
            default:
                throw new Error("unknown type " + type)
        }
    }

    public static async updateCredentials(
        type: string,
        details : { [key: string]: string }
    ) {
        const storage = this.createStorage(type, details)
        const updateCredentials = request.UpdateStorageCreds.create({
            storageType: storage
        })
        const req = request.Request.create({
            id: null,
            updateStorageCreds: updateCredentials
        })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.updateStorageCreds.status)

        if (resp.updateStorageCreds.status !== 0) {
            throw new Error("New Credentials are not set")
        }
    }

    public static async setBYOSCred(
        type: string,
        details: { [key: string]: string }
    ): Promise<String> {
        const storage = this.createStorage(type, details)
        const MigrateToStorage = request.MigrateToStorage.create({
            storageType: storage
        })
        const req = request.Request.create({
            id: null,
            migrateToStorage: MigrateToStorage
        })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.MigrateToStorage.status)

        if (resp.MigrateToStorage.status !== 0) {
            throw new Error("New Credentials are not set")
        }

        return ""
        // resp.MigrateToStorage.message ?? ""
    }

    public static async getStorageCreds() {
        const getStorageCreds = request.GetStorageCreds.create({})
        const req = request.Request.create({
            id: null,
            getStorageCreds: getStorageCreds
        })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.getStorageCreds.status)

        if (resp.getStorageCreds.status !== 0) {
            console.error(resp.getStorageCreds.message ?? "Error in Fetching the storage credentials")
            throw new Error(resp.getStorageCreds.message ?? "Error in Fetching the storage credentials")
        }

        if (resp.getStorageCreds.storageDetails == null || resp.getStorageCreds.storageDetails == undefined){
            console.error("Storage Details are null")
            throw new Error("Storage Details are null")
        }
        return resp.getStorageCreds.storageDetails
    }
}